import { Link } from 'react-router-dom'

function About() {
  return (
    <div className="grow py-8 px-4 sm:px-12 container mx-auto shadow-md flex gap-8 flex-col main-container-height">
      <div className="w-full">
        <h2 className="text-grays-dark text-2xl font-bold mb-4">
          About CTI
        </h2>
        <p className="text-grays-dark font-normal mb-4">
          At CTI, we help automotive professionals build the skills and confidence they need to succeed.
          We provide high quality technical training for technicians and service professionals, along with
          practical business education for shop owners, service advisors, managers, fleets, and
          franchises.
        </p>
        <p className="text-grays-dark font-normal mb-4">
          Since 1999, we’ve been committed to supporting the automotive industry through relevant, real
          world training that makes a difference in the shop every day. Our courses are developed at the
          CTI Research and Development Center in Raleigh, North Carolina, where our team combines
          OE information, hands on vehicle testing, case studies, and real shop experience to create
          training that works in the field.
        </p>
        <p className="text-grays-dark font-normal mb-4">
          Our instructors include factory trained technicians, shop foremen, and industry experts who
          understand the challenges automotive professionals face because they’ve lived them
          themselves. That means every class is built to be practical, up to date, and immediately useful.
        </p>
        <p className="text-grays-dark font-normal mb-4">
          At CTI, we’re proud to help people advance their careers, grow stronger businesses, and
          succeed in a changing industry.
        </p>
        <Link
          to="/"
          className="text-primary hover:underline inline-block w-fit"
        >
          Search Classes
        </Link>
      </div>
      <div className="w-full flex flex-col md:flex-row gap-5 max-h-72 justify-center">
        <div className="mb-4">
          <img
            src="/images/DSC01047.webp"
            className="h-full object-contain"
            alt=""
          />
        </div>
        <div className="mb-4">
          <img
            src="/images/DSC01005.webp"
            className="h-full object-contain"
            alt=""
          />
        </div>
        <div className="mb-4">
          <img
            src="/images/DSC00969.webp"
            className="h-full object-contain"
            alt=""
          />
        </div>
      </div>
    </div>
  )
}

export default About
